module.exports = __webpack_public_path__ + "static/media/emma-plant.8d4e19ec.png";